/** Prevents entity tab URL sync from racing with an intentional leave (e.g. PWA Home). */
let leaveEntityNavigationLock = false;

export function lockLeaveEntityNavigation(): void {
  leaveEntityNavigationLock = true;
}

export function unlockLeaveEntityNavigation(): void {
  leaveEntityNavigationLock = false;
}

export function isLeaveEntityNavigationLocked(): boolean {
  return leaveEntityNavigationLock;
}

export function isOnPwaEntityOrganisationPath(pathname: string): boolean {
  return pathname.includes('/entities/organisation/');
}

/**
 * Prepare to leave an entity organisation page for another in-app route.
 * Locks tab-sync so soft navigation is not raced by URL rewrite.
 *
 * Returns true when the caller should soft-navigate (`navigate(to)`).
 * Never uses `window.location.assign` — a hard load remounts the whole PWA
 * (white flash) and was only a blunt workaround for the tab-sync race.
 */
export function leaveEntityOrganisationPage(
  pathname: string,
  _to: string
): boolean {
  if (!isOnPwaEntityOrganisationPath(pathname)) {
    return false;
  }
  lockLeaveEntityNavigation();
  return true;
}
